import React from 'react';
import { useDiscordAuth } from '../hooks/useDiscordAuth';
import { IconDiscord } from './Icons';
import './DiscordLoginButton.css';

/*
  DiscordLoginButton — drop anywhere in the app.
  Shows login button when logged out, user avatar + name when logged in.
  Props:
    size   — 'sm' | 'md' (default 'md')
    label  — override button text (default 'Log in with Discord')
*/
export default function DiscordLoginButton({ size = 'md', label = 'Log in with Discord' }) {
  const { user, loading, loginWithDiscord, logout } = useDiscordAuth();

  if (loading) {
    return (
      <button className={`discord-btn discord-btn--${size} discord-btn--loading`} disabled>
        <span className="discord-btn__spinner" />
        Connecting…
      </button>
    );
  }

  if (user) {
    return (
      <div className={`discord-user discord-user--${size}`}>
        <img
          src={user.avatar}
          alt={user.username}
          className="discord-user__avatar"
        />
        <div className="discord-user__info">
          <span className="discord-user__name">{user.username}</span>
          <span className="discord-user__tag">PERM Systems member</span>
        </div>
        <button
          className="discord-user__logout"
          onClick={logout}
          aria-label="Log out"
          title="Log out"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
      </div>
    );
  }

  return (
    <button
      className={`discord-btn discord-btn--${size}`}
      onClick={loginWithDiscord}
      aria-label="Log in with Discord"
    >
      <IconDiscord size={size === 'sm' ? 15 : 18} />
      {label}
    </button>
  );
}
